import { defineMessages } from 'react-intl';

export const scope = 'app.components.UpdateCompanyForm.CalibrationSettingsField';

export const messages = defineMessages({
  lblEnableCalibrationVideos: {
    id: `${scope}.lblEnableCalibrationVideos`,
    defaultMessage: 'Enable calibration videos',
  },
  calibrationEnabledHelp: {
    id: `${scope}.calibrationEnabledHelp`,
    defaultMessage: 'When enabled, evaluators are periodically assigned a set of calibration videos to score, drawn from the skills they have recently been scoring.',
  },

  titleAssignmentSize: {
    id: `${scope}.titleAssignmentSize`,
    defaultMessage: 'Assignment size',
  },
  descAssignmentSize: {
    id: `${scope}.descAssignmentSize`,
    defaultMessage: 'How many skills go into a single assignment, and how widely those skills are spread across video clips.',
  },
  lblMaxSkillsPerAssignment: {
    id: `${scope}.lblMaxSkillsPerAssignment`,
    defaultMessage: 'Max calibration skills per assignment',
  },
  helpMaxSkillsPerAssignment: {
    id: `${scope}.helpMaxSkillsPerAssignment`,
    defaultMessage: 'The most skills one assignment can contain. Once an evaluator has this many skills waiting, the assignment is sent as soon as the cooldown allows, without waiting out the delivery window.',
  },
  lblMinSkillsPerAssignment: {
    id: `${scope}.lblMinSkillsPerAssignment`,
    defaultMessage: 'Min calibration skills per assignment',
  },
  helpMinSkillsPerAssignment: {
    id: `${scope}.helpMinSkillsPerAssignment`,
    defaultMessage: 'The fewest skills worth sending. If fewer than this are waiting when the delivery window elapses, the assignment is held back until more accumulate.',
  },
  lblMaxSkillsPerVideoPerAssignment: {
    id: `${scope}.lblMaxSkillsPerVideoPerAssignment`,
    defaultMessage: 'Max skills per video per assignment',
  },
  helpMaxSkillsPerVideoPerAssignment: {
    id: `${scope}.helpMaxSkillsPerVideoPerAssignment`,
    defaultMessage: 'How many different skills may be scored from the same video clip within one assignment. Higher values mean the evaluator watches fewer clips; lower values spread the work across more clips.',
  },

  titleDeliveryTiming: {
    id: `${scope}.titleDeliveryTiming`,
    defaultMessage: 'Delivery timing',
  },
  descDeliveryTiming: {
    id: `${scope}.descDeliveryTiming`,
    defaultMessage: 'When a pending set of skills is released to an evaluator, and how long they have to finish it.',
  },
  lblDeliveryWindowHours: {
    id: `${scope}.lblDeliveryWindowHours`,
    defaultMessage: 'Delivery window (hours)',
  },
  helpDeliveryWindowHours: {
    id: `${scope}.helpDeliveryWindowHours`,
    defaultMessage: 'How long a partly filled assignment waits, measured from the first skill that accumulated, before it is sent. An assignment that reaches the maximum size is sent without waiting.',
  },
  lblAssignmentCooldownHours: {
    id: `${scope}.lblAssignmentCooldownHours`,
    defaultMessage: 'Cooldown between assignments (hours)',
  },
  helpAssignmentCooldownHours: {
    id: `${scope}.helpAssignmentCooldownHours`,
    defaultMessage: 'The minimum gap between two assignments to the same evaluator. Raise it to keep calibration work from arriving in quick succession.',
  },
  lblAssignmentDueDays: {
    id: `${scope}.lblAssignmentDueDays`,
    defaultMessage: 'Days until an assignment is due',
  },
  helpAssignmentDueDays: {
    id: `${scope}.helpAssignmentDueDays`,
    defaultMessage: 'How long an evaluator has to complete an assignment once it has been sent. This sets the due date shown to them.',
  },

  titleEvaluatorWorkload: {
    id: `${scope}.titleEvaluatorWorkload`,
    defaultMessage: 'Evaluator workload',
  },
  descEvaluatorWorkload: {
    id: `${scope}.descEvaluatorWorkload`,
    defaultMessage: 'A rolling cap on how much calibration work any one evaluator is given, no matter how many skills they are scoring.',
  },
  lblPeriodLengthDays: {
    id: `${scope}.lblPeriodLengthDays`,
    defaultMessage: 'Period length (days)',
  },
  helpPeriodLengthDays: {
    id: `${scope}.helpPeriodLengthDays`,
    defaultMessage: 'The length of the rolling window used to count how much calibration work an evaluator has already received.',
  },
  lblMaxSkillsPerPeriod: {
    id: `${scope}.lblMaxSkillsPerPeriod`,
    defaultMessage: 'Max calibration skills per evaluator per period',
  },
  helpMaxSkillsPerPeriod: {
    id: `${scope}.helpMaxSkillsPerPeriod`,
    defaultMessage: 'The most skills one evaluator can be assigned within a period. When too little of the cap is left to fill a minimum-sized assignment, no more are sent until the window rolls forward.',
  },
});
